export default "__VITE_ASSET__CtnwlP$B__"